import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { deleteMenuCategory } from 'api/company';
import { getMenuCategory } from 'api/pathForHook/company';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import { usePermissions } from 'components/backoffice/PermissionsContext';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import FiltersTableMenuMatters from './FiltersTableMenuMatters';
import StatusBudget from 'components/budget/StatusBudget';

const MenuMatters = () => {
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const { t } = useTranslation(['backoffice']);
  const [listCategories, setListCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [responseInfo, setResponseInfo] = useState({});
  const [idItem, setIdItem] = useState();
  const [formFilter, setFormFilter] = useState({
    search: '',
    state: ''
  })
  const { setTitle } = useOutletContext()

  const colsCategories = [
    t('name'),
    t('state'),
    t('includeInMenu'),
    t('actions')
  ];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListCategories = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        search: formFilter.search || '',
        state: formFilter.state || '',
        fields: 'id,name,state,include_on_menu'
      }
      await fetchData(getMenuCategory(), payload);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    setTitle(t('menuMatters'))
    return () => {
      setTitle('');
    };
  },[setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListCategories(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setListCategories(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  useEffect(() => {
    getListCategories();
  }, [page, formFilter]);

  const handleClear = () => {
    setFormFilter({
      state: 'ninguno',
      search: ''
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
  };

  const handleCreate = () => navigate('/intranet/menu-matters/create');
  const handleEdit = (id) => navigate(`/intranet/menu-matters/edit/${id}`);

  const handleShowModalDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteMenuCategory(idItem);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        getListCategories();
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.error(error);
      toast.error(`${t('error')}: ${t('mensajeerror')}`);
    }
  }, [idItem]);

  const serializerCategoryStatus = (state) => {
    if (!state) {
      return 'danger'; 
    } else if (state) {
      return 'success'; 
    }
    return 'info'; 
  };
  
  return (
    <div className="d-lg-grid">
      <Title text={t('menuMatters')} />
      <Row className="d-flex w-md-100 mt-3">
      <Col md={9} xs={12} className="d-flex text-start">
          <FiltersTableMenuMatters
            formFilter={formFilter}
            handleClear={handleClear}
            setFormFilter={setFormFilter}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col md={3} xs={12} className="d-flex text-end align-bottom p-md-0 justify-content-end pt-5 pt-md-0">
          {userPermissions.includes('empresa.__add') && (
            <Button color="primary" onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsCategories}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listCategories?.map((category, index) => (
            <tr key={category.id}>
              <td className='text-truncate-td' title={category.name}>{category.name}</td>
              <td>
                <div className="d-flex justify-content-center">
                  <StatusBudget
                    text={category.state ? t('activo') : t('faqs.inactive')}
                    status={serializerCategoryStatus(category.state)}
                  />
                </div>
              </td>
              <td>{category.include_on_menu ? t('si') : t('no')}</td>
              <td className="item-dropdown text-end">
                <DropdownIcons
                  idItem={index}
                  handleEdit={
                    userPermissions.includes('empresa.__modify') &&
                    (() => handleEdit(category.id))
                  }
                  handleDelete={
                    userPermissions.includes('empresa.__delete') &&
                    (() => handleShowModalDelete(category, category.id, setShowModalDelete))
                  }
                />
              </td>
            </tr>
          ))}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={showModalDelete}
        setOpenModal={setShowModalDelete}
        handleDelete={handleDelete}
        deleteTitle={t('deleteMenuMatters')}
        beforeTitle={t('menuMatters')}
      />
    </div>
  );
};

export default MenuMatters;